/* globals $: true, Codsec: true*/

this.Codsec = this.Codsec || {};

Codsec.appList = {
	_owl : null,
	_carouselOptions : function() {
		return {
			margin          : 20,
			loop            : true,
			items           : 3,
			navigation      : $('.appList .appBlock').length > 3,
			responsiveClass : true,
			responsive:{
				0 : {
						items : 1.2,
						nav   : false
				},
				600 : {
						items : 2.2,
						nav   : false
				},
				750 : {
						items : 3,
						nav   : $('.appList .appBlock').length > 3,
				}
			}
		};
	},
	carousel : function() {
		this._owl = $('#app-list-container');

		this._owl.owlCarousel(this._carouselOptions());

		this._owl.on('mousewheel', '.owl-stage', function (e) {
			if (e.originalEvent.wheelDeltaY) {
					return;
			}

			if (e.originalEvent.wheelDeltaX<0) {
					this._owl.trigger('next.owl');
			} else {
					this._owl.trigger('prev.owl');
			}

			e.preventDefault();
		});
	},

	destroyCarousel : function() {
		this._owl.trigger('destroy.owl.carousel');
	},

	reinitCarousel : function() {
		this._owl.owlCarousel(this._carouselOptions());
	},

	attachAllAppListener : function() {
		var owl = this._owl,
			self = this,
			$allApps = $('.showAllApps').html();

		$('.showAllApps').on('click', function(e) {
			if ( owl.hasClass('off') ) {
				$('.filler').remove();
				$(this).html($allApps);
				$(this).removeClass('orange');

				self.reinitCarousel();
				owl.removeClass('off');

			} else {
				$(this).html('Switch back to slider view');
				$(this).addClass('orange');

				owl.animate({
					'opacity':0
				}, 420);

				setTimeout(function(){
					owl.addClass('off').trigger('destroy.owl.carousel');
					owl.find('.owl-stage-outer').children(':eq(0)').unwrap();

					$('.appList').append('<div class="appBlock filler">');

					$('.appBlock').css({'opacity':0});

					$('.appBlock').each(function(i, el) {
						if(i === 1) {
							owl.animate({
								'opacity':1
							}, 0);
						}

						setTimeout(function(){
							$(el).animate({
								'opacity':1.0
							}, 100);
						}, 100 + ( i * 200 ));
					});
				},100);
			}
		});
	}
};
